export default {
  data () {
    return {
      collapsedDividers: {}
    }
  },

  created () {
  },

  methods: {
    toggleDivider (dividerId) {
      this.$set(
        this.collapsedDividers,
        dividerId,
        !this.collapsedDividers[dividerId]
      )
    },

    isDividerCollapsible (colId) {
      const field = this.formFields[colId]
      if (!field || field.type !== 'divider') return false
      return field.collapsed !== null && field.collapsed !== undefined
    },

    getVisibleRows (rows, fields) {
      let hidden = false

      return rows.filter(row => {
        const dividerCol = row.cols.find(
          col => fields[col]?.type === 'divider'
        )

        if (dividerCol) {
          // Initialize collapsedDividers for new dividers
          if (!this.collapsedDividers.hasOwnProperty(dividerCol) && this.isDividerCollapsible(dividerCol)) {
            this.$set(
              this.collapsedDividers,
              dividerCol,
              !!fields[dividerCol].collapsed
            )
          }

          hidden = !!this.collapsedDividers[dividerCol]
          return true
        }

        return !hidden
      })
    }
  }
}
